export const getCategoryLabel = (area: string | undefined): string => {
  switch (area) {
    case 'comp':
      return 'Text';
    case 'math':
      return 'Strand';
    case 'listening':
      return 'Stimulus';
    default:
      return 'Question Category';
  }
};

export const getCategoryTypeLabel = (area: string | undefined): string => {
  switch (area) {
    case 'comp':
      return 'Text Type';
    case 'listening':
      return 'Stimulus Type';
    default:
      return '';
  }
};

export const getCategoryToggleLabel = (area: string | undefined): string => {
  switch (area) {
    case 'comp':
      return 'Show Text View';
    case 'math':
      return 'Show Strand View';
    case 'listening':
      return 'Show Stimulus View';
    default:
      return 'Show Category View';
  }
};

export const getCategoryViewLabel = (area: string | undefined): string => {
  switch (area) {
    case 'comp':
      return 'Text View';
    case 'math':
      return 'Strand View';
    case 'listening':
      return 'Stimulus View';
    default:
      return 'Category View';
  }
};
